module.exports = __webpack_public_path__ + "static/img/Mitsuko Nishikawa.jpg";